

















import { Component, Vue, Emit, Prop } from 'vue-property-decorator';
import { ElementType } from '../../../core/utils';

@Component
export default class ListElement extends Vue {
    @Prop() elements: ElementType[];
    @Prop() elementSelected: ElementType | null;

    @Emit()
    select(elementSelected: ElementType) {}

    isElementSelected(name: string): boolean {
        if (this.elementSelected !== null) {
            return this.elementSelected.name === name;
        } else {
            return false;
        }
    }
}
